import { Form } from "antd"
import { forwardRef, useImperativeHandle, useState } from "react"
import { Button, Drawer, Group, notification } from "components/common"
import AddReviewFormContent from "./components/AddReviewFormContent"
import { t } from "i18next"
import { useAddReviewLeadMutation } from "features/leads/api"
import AddReviewDetailCard from "./components/AddReviewDetailCard"
import { useEntityApis } from "./utils/useEntityApisHook"

const AddLeadReviewDrawer = forwardRef(({ lead, client, selectedCall, className }, ref) => {
  const [form] = Form.useForm()
  const [showDrawer, setShowDrawer] = useState(false)
  const [preSelection, setPreSelection] = useState({})

  const clientId = client?.clientId ?? client?.id
  const entityApiMap = useEntityApis({ clientId })

  const [reviewLead, { isLoading, isError, error }] = useAddReviewLeadMutation()
  const entityToReview = Form.useWatch("entityToReview", form)
  const selectedEntityFromForm = Form.useWatch("entity", form)

  useImperativeHandle(ref, () => ({
    setVisible: payload => {
      if (!!payload?.preSelectMeeting) {
        setPreSelection({ preSelectMeeting: true, meeting: payload?.meeting })
      } else if (!!payload?.preSelectCall) {
        setPreSelection({ preSelectCall: true, callRecord: payload?.callRecord })
      } else if (!!payload?.preSelectLead) {
        setPreSelection({ preSelectLead: true, lead: payload?.lead })
      }
      setShowDrawer(true)
    },
  }))

  const onClose = () => {
    setShowDrawer(false)
    setPreSelection({})
    form.resetFields()
  }

  const onSubmit = values => {
    reviewLead({ inquiryId: lead?.id, phoneCallId: selectedCall?.phoneCallId, ...values })
      .unwrap()
      .then(response => {
        notification?.success({ message: t("Review added successfully!") })
        setPreSelection({})
        form.resetFields()
        setShowDrawer(false)
      })
      .catch(e => notification.error({ message: e?.message }))
  }

  return (
    <Drawer
      title={t("Add Review")}
      placement="right"
      width={1100}
      open={showDrawer}
      onClose={onClose}
      className={className}
      closable
      destroyOnClose
      footer={
        <div style={{ textAlign: "right" }}>
          <Button style={{ marginRight: 8 }} onClick={onClose} text={t("Cancel")} />
          <Button
            type="primary"
            disabled={isLoading}
            onClick={() => form.submit()}
            text={t("Submit")}
            loading={isLoading}
          />
        </div>
      }
    >
      <Group template="minmax(380px, 0.5fr) 1fr" gap="24px 32px" style={{ alignItems: "start" }}>
        <AddReviewDetailCard
          client={client}
          entityToReview={entityToReview}
          data={selectedEntityFromForm}
          preSelection={preSelection}
          entityApiMap={entityApiMap}
        />
        <AddReviewFormContent
          form={form}
          clientId={clientId}
          leadId={lead?.id}
          onSubmit={onSubmit}
          preSelection={preSelection}
          entityApiMap={entityApiMap}
        />
      </Group>
    </Drawer>
  )
})

export default AddLeadReviewDrawer
